import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { 
  faFacebookSquare,
  faGoogle 
} from '@fortawesome/free-brands-svg-icons'
import { 
  faSearch,
  faBars,
  faUser,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faPlus
} from '@fortawesome/free-solid-svg-icons'


library.add(
  faFacebookSquare,
  faGoogle,
  faSearch,
  faBars,
  faUser,
  faFilter,
  faSort,
  faSortUp,
  faSortDown,
  faPlus
)

Vue.component('font-awesome-icon', FontAwesomeIcon)